import * as React from "react"
import { Context } from "@contexts/MembershipLayoutCtx.tsx"

const useMembershipLayoutCtx = () => React.useContext(Context)

export default useMembershipLayoutCtx
